import type { Meta, StoryFn } from '@storybook/react';
import type { StatusPillProps } from './StatusPill';

import { StatusPill } from './StatusPill';

import { Container } from 'storyComponents/Container';

const codeString = '<StatusPill  status={status} label={label} variant={variant}/>';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Molecules/StatusPill',
  component: StatusPill,
  parameters: {
    inspectComponent: StatusPill,
    codeString: codeString,
  },
} as Meta<StatusPillProps>;

const Template: StoryFn<StatusPillProps> = (args) => (
  <Container>
    <StatusPill {...args} />
  </Container>
);

export const StatusPillExample = Template.bind({});
StatusPillExample.args = {
  status: 'possible',
  variant: 'default',
  label: 'Example Status Pill',
};
